import {createAction} from 'redux-actions'
import {
  OAUTH_GET_USER_APPS,
  OAUTH_REMOVE_PERMISSIONS
} from '@rambler-id/transport'
import {apiV3} from 'utils/transport'
import {sentryReact as Sentry} from '@rambler-id/sentry'
import {throwError} from 'containers/App/actions'

export const updateApps = createAction('UPDATE_APPS')
export const cancelPermissions = createAction('CANCEL_PERMISSIONS')

export const loadApps = () => async (dispatch) => {
  try {
    const {apps} = await apiV3(`/legacy/${OAUTH_GET_USER_APPS}`)

    dispatch(updateApps(apps))
  } catch (error) {
    if (error.code === 0 || error.code === -17) {
      dispatch(
        throwError(
          'По техническим причинам отображены не все данные. При необходимости перезагрузите страницу.',
          error
        )
      )

      return
    }

    Sentry.captureException(error)
  }
}

export const removePermissions = (clientId) => async (dispatch) => {
  try {
    await apiV3(`/legacy/${OAUTH_REMOVE_PERMISSIONS}`, {clientId})
    dispatch(cancelPermissions(clientId))
  } catch (error) {
    Sentry.captureException(error)
    dispatch(throwError('Не удалось удалить приложение', error))
  }
}
